


















import { Component, Vue } from 'vue-property-decorator';
import ToolBox from '@/components/common/ToolBox.vue';
import APPInfo from '@/components/designer/APPInfo.vue';
import { APP } from '@/api/com/MetaPattern/MDA/MD/Base/APP';
import { MDRepository } from '@/libs/com/MetaPattern/MDA/MD/MDRepository';
import { IDEContext } from '@/libs/com/MetaPattern/Product/IDE/IDEContext';
import HelpIcon from '@/components/common/HelpIcon.vue';
import AddAPP from '@/components/MDA/MD/AddAPP.vue';
import { EventBus } from '@/libs/com/MetaPattern/Product/IDE/Util/EventBus';
@Component({
  components: {
    ToolBox,
    APPInfo,
    HelpIcon,
    AddAPP
  }
})
export default class APPScope extends Vue {
  private showAddAPP = false;
  private newAPP: APP;
  private key = 0;

  constructor() {
    super();
    this.showAddAPP = false;
    this.newAPP = null;
  }

  getAppCount(): number {
    return IDEContext.instance.filterMyAPPs(this.$store.state.ModuleMD.apps).length;
  }

  /** 添加一个新的应用，并创建APP组件 */
  addAPP(): void {
    this.key++;
    this.newAPP = null;
    this.showAddAPP = true;
  }

  closeEdit(entity: APP) {
    this.showAddAPP = false;
    if (entity !== null) {
      MDRepository.createNewAPPAsync(entity.name, entity.displayName, entity.description, entity.aPPKey, entity.rootNamespace, entity.workScope_ID).then((app) => {
        app.workScope = entity.workScope;
        const apps = this.$store.state.ModuleMD.apps as Array<APP>;
        apps.push(app);
        this.$store.dispatch('ModuleMD/setAppsAction', apps);
        if (app.aPPComponents.length > 0) {
          const component = app.aPPComponents[0];
          this.$store.dispatch('ModuleMD/setCurMDDesignIdAction', component.designId);
          EventBus.$emit('openDoc', component);
        }
      });
    }
  }
}
